import React, { useContext } from "react";
import { FaRegStar, FaStar, FaStarHalfAlt, FaTag } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { MyContext } from "../../../context/MyContext";

const ProductSearch = () => {
  const { search, serchItem } = useContext(MyContext);
  const navigate = useNavigate();
  const renderStars = (rating, maxRating = 5) => {
    const stars = Array.from({ length: maxRating }, (_, index) => {
      const currentRating = index + 1;
      if (rating >= currentRating) {
        return <FaStar key={index} className="text-gray-600" />;
      } else if (rating >= currentRating - 0.5) {
        return <FaStarHalfAlt key={index} className="text-gray-600" />;
      } else {
        return <FaRegStar key={index} className="text-gray-600" />;
      }
    });
    return <div className="flex">{stars}</div>;
  };

  const handleProductClick = (productId) => {
    navigate(`/products/${productId}`);
  };

  const calculateDiscount = (salePrice, oldPrice) => {
    let saleP = Number(salePrice);
    let oldP = Number(oldPrice);

    // console.log(`Sale Price: ${saleP}, Old Price: ${oldP}`);

    if (!saleP || !oldP || oldP <= saleP) {
      // console.log("Discount cannot be calculated.");
      return 0;
    }

    let discount = Math.round(((oldP - saleP) / oldP) * 100);
    // console.log(`Calculated Discount: ${discount}%`);
    return discount;
  };

  return (
    <section className="mx-auto p-10 xl:p-10 pt-4 md:pt-2 lg:pt-40">
      <div className="flex justify-start items-center text-lg sm:text-xl md:text-2xl lg:text-3xl py-3">
        <h2>
          Showing result : <span className="text-blue-500">{serchItem}</span>
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 ">
        {search &&
          search?.map((product) => (
            <div
              key={product.id}
              onClick={() => handleProductClick(product.id)}
              className="group relative bg-white shadow-sm border-2 rounded-lg overflow-hidden transform transition-transform duration-700 ease-in-out hover:scale-[1.02]"
            >
              <Link to={`/products/${product?.id}`}>
                <div className="relative">
                  <img
                    src={`${process.env.REACT_APP_NODE_CATEGORY}uploads/product/${product?.featured_image}`}
                    alt={product?.name}
                    className="object-cover w-full h-48"
                  />
                  <div className="absolute top-1 left-1 bg-purple-500 text-white px-2 py-1 rounded-full text-[10px] flex items-center">
                    <FaTag className="mr-1" />
                    {`${calculateDiscount(
                      product?.price[0]?.config[0][0]?.sale_price,
                      product?.price[0]?.config[0][0]?.sale_price
                    )}% OFF`}
                   
                  </div>
                </div>
                <div className="p-4">
                  <p className="text-start text-sm font-semibold mb-2">
                    {product?.name?.slice(0, 50)}
                  </p>
                  
                  <div className="text-sm text-gray-600 mb-2 sm:mb-1">
                    {renderStars(product?.rating)}
                  </div>
                  <div className="flex items-center space-x-2 mb-2 sm:mb-1">
                    <span className="text-sm font-bold text-green-500">
                      ₹{product?.price[0]?.config[0][0]?.sale_price}
                    </span>
                    <span className="text-sm text-gray-500 line-through">
                      ₹{product?.price[0].config[0][0]?.old_price}
                    </span>
                  </div>
                  <p className="font-semibold text-sm text-orange-500">
                    Coins:{product?.coin}
                  </p>
                </div>
              </Link>
            </div>
          ))}
      </div>
    </section>
  );
};

export default ProductSearch;
